module.exports = __webpack_public_path__ + "img/Image_5.b83e660e.png";